export const downloadFile = async (href, filename) => {
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
};
